'use client';

import { Box } from '@terra/ui-styled-system';
import { SimpleMatchReplaceTab } from './SimpleMatchReplaceTab';

export function MatchReplaceTabWrapper() {
  return (
    <Box h="full" w="full" overflow="hidden">
      <SimpleMatchReplaceTab />
    </Box>
  );
}
